export default __webpack_public_path__ + "static/media/thai_utmb_logo.ed4735ab.svg";